"use client";

import { useState } from "react";
import SinglePriceCard from "./SinglePriceCard";

const searchPricingList = [
  {
    intro: "Business",
    subtitle: "For teams needing unified search.",
    price: null,
    customHeaderText: "Search Business",
    buttonText: "Contact Sales",
    featureList: [
      "Unified Search",
      "Conversational AI",
      "Standard Connectors",
      "Enterprise Knowledge Graph",
      "AI agents with tools & actions",
      "Native connectors (Slack, Jira, etc.)",
      "Bring your own LLM",
    ],
  },
  {
    intro: "ENTERPRISE",
    subtitle: "For max security & on-prem needs.",
    price: null,
    customHeaderText: "Search Enterprise",
    buttonText: "Contact Sales",
    featureList: [
      "Self-hosted / Private Cloud",
      "Custom Connectors",
      "Advanced reasoning & long-context",
      "Domain / role-specific agents",
      "API & webhooks",
      "SSO (SAML / OAuth)",
    ],
  },
];

const SearchPricingCardsArea = () => {
  const [highlightPackage, setHighlightPackage] = useState<number | null>(null);

  return (
    <div>
      <div className="mt-[8px] xl:mt-[12px]">
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:gap-4">
          {searchPricingList.map((item, index) => (
            <SinglePriceCard
              setHighlightPackage={setHighlightPackage}
              info={item}
              key={index}
              defaultShow={index + 1 === highlightPackage}
              packageTime="yearly"
              packageNumber={index + 1}
              highlightPackage={highlightPackage}
              isDark={index === 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchPricingCardsArea;
